// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__1PIAy","cardcontent":"card_cardcontent__1bYNk","card_title":"card_card_title__2OGle","Button":"card_Button__3uRdp","App":"card_App__swHG5"};